import React from "react";
import { Grid } from "@mui/material";

const Advertisement = () => {
  return (
    <div className="flex items-center justify-between pt-7 flex-col-reverse lg:flex-row">
      <div className="lg:w-1/2">
        <img src="https://theprakritistory.com/wp-content/uploads/2021/11/Monday-Flashback-6-%E2%80%93-Hawa-Mahal-Jaipur-1.jpg" />
      </div>
      <div className="lg:w-1/2 lg:p-7">
        <h3 className="text-center text-xl font-bold lg:mb-2 text-[#b28585]">
          Aashapura Safa House
        </h3>
        <p className="text-center text-[#b28585] p-9">
          "India's No. 1 Bespoke Online Celebration Wear Brand" Inspired from
          legacy of Royal Rajputana "The Heart of Indian Culture and Rich
          Heritage", we are aspired to revolutionize Indian Ethnic Fashion. Our
          uniqueness lies in our belief that apparel chosen with love and
          aspiration for special days , festivals and celebrations deserves
          special craft , skillfull hands, curated designing , precious time and
          love. Royal wali baraat, Aashapura Safa House ke saath!
        </p>
      </div>
    </div>
  );
};

export default Advertisement;
